import Actions from 'actions';

const initialState = Object.freeze([]);

function attendList(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_ATTENDING_EVENTS_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_ATTENDING_EVENTS_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default attendList;
